import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  copy() {
    const target = $(".js-text-copy-target").val();

    navigator.clipboard
      .writeText(target)
      .then(function () {
        const html =
          '<div class="toast js-toast is-hide" aria-live="polite" data-controller="toast">' +
          '<p class="toast__text">テキストをコピーしました</p>' +
          '<button type="button" class="toast__button js-toast-close" data-action="toast#close">トーストメッセージを閉じる</button>' +
          "</div>";
        $("#toast_messages").html(html);
      })
      .catch(function () {
        const html =
          '<div class="toast toast--error js-toast-error is-hide" aria-live="polite" data-controller="toast">' +
          '<p class="toast__text">テキストのコピーに失敗しました</p>' +
          '<button type="button" class="toast__button js-toast-close" data-action="toast#close">トーストメッセージを閉じる</button>' +
          "</div>";
        $("#toast_messages").html(html);
      });
  }
}
